import axios from 'axios';

export const api = axios.create({
  // baseURL: 'http://localhost:3001/tasks',
  baseURL: 'https://middleware-agendor-renegustavo.vercel.app/api',
});
